import React, { useState } from 'react';
import './UserForm.css';
import '../../../shared/StyledInput.css';
import RequiredMark from '../../../shared/RequiredMark';
import CancelButton from '../../../shared/CancelButton';
import SaveButton from '../../../shared/SaveButton';

// roles: every Role on the tenant, for the Roles picker (issue #252). A
// staff member holds at least one; their permissions are the combination
// of all of them.
function UserForm({ initial, roles = [], onSave, onCancel, loading }) {
  const [name, setName] = useState(initial?.name || '');
  const [email, setEmail] = useState(initial?.email || '');
  const [roleIds, setRoleIds] = useState(() => (initial?.roles || []).map((role) => role.id));
  const [error, setError] = useState('');

  const validate = () => {
    if (!name.trim()) return 'Name is required.';
    if (!email.trim()) return 'Email is required.';
    if (!roleIds.length) return 'Pick at least one role.';
    return '';
  };

  const toggleRole = (id, checked) => {
    setRoleIds((prev) => (checked ? [...prev, id] : prev.filter((roleId) => roleId !== id)));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const err = validate();
    if (err) return setError(err);
    setError('');
    onSave({
      name: name.trim(),
      email: email.trim(),
      role_ids: roleIds,
    });
  };

  return (
    <form className="user-form" onSubmit={handleSubmit} style={{ minWidth: 320 }}>
      <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
        <div>
          <label>Name<RequiredMark /></label><br />
          <input
            className="styled-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            maxLength={150}
            placeholder="e.g., Dana Smith"
            style={{ width: 220 }}
          />
        </div>
        <div>
          <label>Email<RequiredMark /></label><br />
          <input
            className="styled-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            maxLength={150}
            placeholder="e.g., dana@example.com"
            style={{ width: 260 }}
          />
        </div>
      </div>

      <div style={{ marginTop: 12 }}>
        <label>Roles<RequiredMark /></label>
        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginTop: 4 }}>
          {roles.map((role) => (
            <label key={role.id} style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 14, cursor: 'pointer' }}>
              <input type="checkbox" checked={roleIds.includes(role.id)} onChange={(e) => toggleRole(role.id, e.target.checked)} />
              {role.name}
            </label>
          ))}
        </div>
      </div>

      {error && <div style={{ color: 'red', marginTop: 8 }}>{error}</div>}

      <div style={{ marginTop: 12 }}>
        <SaveButton loading={loading} />
        <CancelButton onClick={onCancel} disabled={loading} style={{ marginLeft: 8 }} />
      </div>
    </form>
  );
}

export default UserForm;
